import { authApi, defaultApi } from "@/services/axiosInstances";
import { startSilentAuth } from "@/utils/silentAuth";
import { createStore } from "vuex";

export default createStore({
	state: {
		token: null,
		user: null,
		roles: [],
		semester: null,
		authenticating: true,
		loading: true,
	},
	getters: {
		getToken: (state) => state.token,
		getUser: (state) => state.user,
		getRoles: (state) => state.roles,
		getSemester: (state) => state.semester,
		isAuthenticating: (state) => state.authenticating,
		isLoading: (state) => state.loading,
	},
	mutations: {
		setToken(state, val) {
			state.token = val;
		},
		setUser(state, val) {
			state.user = val;
		},
		setUserPhoto(state, val) {
			if (state.user.foto) state.user.fotoPath = val;
		},
		setRoles(state, val) {
			state.roles = val;
		},
		setSemester(state, val) {
			state.semester = val;
		},
		setAuthenticating(state, val) {
			state.authenticating = val;
		},
		stopLoading(state) {
			state.loading = false;
		},
	},
	actions: {
		async loadAuth({ commit, dispatch }) {
			const token = localStorage.getItem("token");
			commit("setToken", token);

			if (token) {
				const verify = await dispatch("verifyToken");
				if (verify.success) {
					await dispatch("fetchMainData");
					commit("setAuthenticating", false);
					setTimeout(() => {
						commit("stopLoading");
					}, 500);
					return;
				}
			}

			const resAuth = await startSilentAuth();
			if (resAuth.success) {
				dispatch("updateToken", { token: resAuth.token });

				await dispatch("verifyToken");

				await dispatch("fetchMainData");
				commit("setAuthenticating", false);
				setTimeout(() => {
					commit("stopLoading");
				}, 500);
				return;
			}

			commit("setAuthenticating", false);
			setTimeout(() => {
				dispatch("clearAuth");
				commit("stopLoading");
			}, 500);
		},
		async verifyToken({ commit }) {
			try {
				const { data, status } = await authApi.post("/verify");

				commit("setUser", data.user);
				commit("setUserPhoto", process.env.VUE_APP_AUTH_API + "/profile/photo?ts=" + Date.now());

				return { data, success: status === 200 };
			} catch (error) {
				console.error(error.response?.data?.message);
				return { success: false };
			}
		},
		async fetchMainData({ commit }) {
			try {
				const { data } = await defaultApi.get("/auth/session");

				commit("setRoles", data.data.roles);
				commit("setSemester", data.data.semester_aktif);
			} catch (error) {
				console.error(error.response?.data?.message);
				commit("setRoles", []);
				commit("setSemester", null);
			}
		},
		updateToken({ commit }, data) {
			commit("setToken", data.token);
			localStorage.setItem("token", data.token);
		},
		async logoutUser({ dispatch }) {
			try {
				await authApi.post("/logout");
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("clearAuth");
			}
		},
		clearAuth({ commit }) {
			localStorage.removeItem("token");
			commit("setAuthenticating", true);
			commit("setToken", null);
			commit("setUser", null);
			commit("setRoles", []);
			setTimeout(() => {
				window.location.href = `${process.env.VUE_APP_SSO_URL}?appId=${process.env.VUE_APP_ID}`;
			}, 500);
		},
	},
	modules: {},
});
